import type { ProtocolOption } from 'bundles/widget-simulator/types';

export const DEFAULT_PROTOCOL = 'http';

export const PROTOCOL_OPTIONS: Array<ProtocolOption> = [
  { label: 'http://', value: 'http' },
  { label: 'https://', value: 'https' },
];
